export const tooltipTrigger = ['hover', 'click'];
